// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'flag-wave';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1 17V1m0 11.905 2.243-.688a6.848 6.848 0 0 1 5.591.71 6.848 6.848 0 0 0 5.46.752l2.125-.606a.8.8 0 0 0 .58-.767V3.987a.799.799 0 0 0-1.02-.767l-1.684.481a6.853 6.853 0 0 1-5.46-.75 6.844 6.844 0 0 0-5.592-.708L1 2.929'
  />
);

export const viewBox = '0 0 18 18';
